import BenefitsWidget from './BenefitsWidget.jsx';

export default BenefitsWidget;
